module.exports = (component, spec) => {
  if (spec.query == null)
    return component.query = () => ({})
  component.query = params => spec.query.call(component, params)
}
